import React from 'react';
import { Button } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import {
  openClientDetailsNav,
  closeClientDetailsNav,
  handleClientFieldValueChange
} from './ClientDetailsPanel.utils';

interface ClientDetailsPanelProps {
  clientDetails: { [key: string]: string };
  clientDetailsOpen: boolean;
  setClientDetailsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setClientDetails: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
  setRecipientOptions: React.Dispatch<React.SetStateAction<{ label: string; value: string }[]>>;
  forwizard?: boolean;
}

const ClientDetailsPanel: React.FC<ClientDetailsPanelProps> = ({
  clientDetails,
  clientDetailsOpen,
  setClientDetailsOpen,
  setClientDetails,
  setRecipientOptions,
  forwizard,
}) => {
  return (
    <div>
      {/* Client Details Toggle Button */}
      <div
        className={
          clientDetailsOpen
            ? 'clientdetails-button-wrapper clientdetails-active'
            : 'clientdetails-button-wrapper'
        }
        style={{ display: forwizard ? 'none' : '' }}
      >
        <Button
          className="flex-column-center-center clientdetails-button"
          onClick={() => clientDetailsOpen ? closeClientDetailsNav(setClientDetailsOpen) : openClientDetailsNav(setClientDetailsOpen)}
        >
          <Icon.PersonBadge
            style={{ color: 'gray', fontSize: 16, marginBottom: 0 }}
          />
          <p>Client Details</p>
        </Button>
      </div>

      {/* Client Details Form */}
      <div
        id="clientdetails"
        className={clientDetailsOpen ? 'clientdetails fields-section-active' : 'clientdetails'}
      >
        <div className="clientdetails-content">
          <div className="clientdetails-column">
            {Object.entries(clientDetails).map(([key, value]) => (
              <div key={key} className="clientdetails-row">
                <label htmlFor={key} className="clientdetails-label">
                  {key}:
                </label>
                <input
                  type="text"
                  id={key}
                  className="clientdetails-input"
                  value={value}
                  onChange={(e) =>
                    handleClientFieldValueChange(setClientDetails, setRecipientOptions, clientDetails, e, key)
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDetailsPanel;
